import React, { useState, useEffect } from 'react';
import { Form, Select } from 'antd';
import { usePmCode, useCmCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';

interface FormItemProps {
  form: any,
  pm?: string,
  cm?: string,
}

const PmCmFormItem = ({form, pm, cm}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [ includePm, setIncludePm ] = useState<string>("");
  const [ includeCm, setIncludeCm ] = useState<string>("");

  /* ======================================================
  * hooks
  * ====================================================== */
  const { pmCodeList } = usePmCode({include:includePm});   
  const { cmCodeList } = useCmCode({include:includeCm});  

  /* ======================================================
  * events
  * ====================================================== */  

  /* ======================================================
  * effects
  * ====================================================== */  

  useEffect(() => {
      if (pm) setIncludePm(pm);
      if (cm) setIncludeCm(cm);

  }, [pm, cm])

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <div>
        <Form.Item style={{ display: 'inline-block'}}>
          <label>PM :&nbsp;</label>
        </Form.Item>     
        <Form.Item name="pm" style={{ width:'180px', display: 'inline-block'}}>
          <Select 
            placeholder="PM 선택" 
            mode="multiple" 
            allowClear 
            optionFilterProp="label"
            filterOption={selectBoxFilterOption}
            options={pmCodeList} />     
        </Form.Item> 
      </div>
      <div>
        <Form.Item style={{ display: 'inline-block'}}>
          <label>CM :&nbsp;</label>
        </Form.Item>         
        <Form.Item name="cm" style={{ width:'180px', marginTop:'5px', display: 'inline-block'}}>
          <Select 
            placeholder="CM 선택" 
            mode="multiple" 
            allowClear 
            optionFilterProp="label"
            options={cmCodeList} />                
        </Form.Item>  
      </div> 
    </>
  );
};

export default PmCmFormItem;
